import { lazy } from 'react';
import { retry } from '@/utils/helpers/common';

// Product Type pages
export const ProductTypeListPage = lazy(
  () =>
    retry(() => import('@/pages/setting/product-types/list')) as Promise<
      typeof import('@/pages/setting/product-types/list')
    >
);

export const ProductTypeEditPage = lazy(
  () =>
    retry(() => import('@/pages/setting/product-types/edit')) as Promise<
      typeof import('@/pages/setting/product-types/edit')
    >
);

export const ProductTypeCreatePage = lazy(
  () =>
    retry(() => import('@/pages/setting/product-types/create')) as Promise<
      typeof import('@/pages/setting/product-types/create')
    >
);

// Business Unit pages
export const BusinessUnitListPage = lazy(
  () =>
    retry(() => import('@/pages/setting/business-unit/list')) as Promise<
      typeof import('@/pages/setting/business-unit/list')
    >
);

export const BusinessUnitEditPage = lazy(
  () =>
    retry(() => import('@/pages/setting/business-unit/edit')) as Promise<
      typeof import('@/pages/setting/business-unit/edit')
    >
);

export const BusinessUnitCreatePage = lazy(
  () =>
    retry(() => import('@/pages/setting/business-unit/create')) as Promise<
      typeof import('@/pages/setting/business-unit/create')
    >
);

// Business Line pages
export const BusinessLineListPage = lazy(
  () =>
    retry(() => import('@/pages/setting/business-lines/list')) as Promise<
      typeof import('@/pages/setting/business-lines/list')
    >
);

export const BusinessLineEditPage = lazy(
  () =>
    retry(() => import('@/pages/setting/business-lines/edit')) as Promise<
      typeof import('@/pages/setting/business-lines/edit')
    >
);

export const BusinessLineCreatePage = lazy(
  () =>
    retry(() => import('@/pages/setting/business-lines/create')) as Promise<
      typeof import('@/pages/setting/business-lines/create')
    >
);

// Product Line pages
export const ProductLineListPage = lazy(
  () =>
    retry(() => import('@/pages/setting/product-lines/list')) as Promise<
      typeof import('@/pages/setting/product-lines/list')
    >
);

export const ProductLineEditPage = lazy(
  () =>
    retry(() => import('@/pages/setting/product-lines/edit')) as Promise<
      typeof import('@/pages/setting/product-lines/edit')
    >
);

export const ProductLineCreatePage = lazy(
  () =>
    retry(() => import('@/pages/setting/product-lines/create')) as Promise<
      typeof import('@/pages/setting/product-lines/create')
    >
);

// Studio pages
export const StudioListPage = lazy(
  () =>
    retry(() => import('@/pages/setting/studios/list')) as Promise<
      typeof import('@/pages/setting/studios/list')
    >
);

export const StudioEditPage = lazy(
  () =>
    retry(() => import('@/pages/setting/studios/edit')) as Promise<
      typeof import('@/pages/setting/studios/edit')
    >
);

export const StudioCreatePage = lazy(
  () =>
    retry(() => import('@/pages/setting/studios/create')) as Promise<
      typeof import('@/pages/setting/studios/create')
    >
);

// Term Condition pages
export const TermConditionListPage = lazy(
  () =>
    retry(() => import('@/pages/setting/term-conditions/list')) as Promise<
      typeof import('@/pages/setting/term-conditions/list')
    >
);

export const TermConditionEditPage = lazy(
  () =>
    retry(() => import('@/pages/setting/term-conditions/edit')) as Promise<
      typeof import('@/pages/setting/term-conditions/edit')
    >
);

export const TermConditionCreatePage = lazy(
  () =>
    retry(() => import('@/pages/setting/term-conditions/create')) as Promise<
      typeof import('@/pages/setting/term-conditions/create')
    >
);

// Externality Reasons pages
export const ExternalityReasonsListPage = lazy(
  () =>
    retry(() => import('@/pages/setting/externality-reasons/list')) as Promise<
      typeof import('@/pages/setting/externality-reasons/list')
    >
);

export const ExternalityReasonsEditPage = lazy(
  () =>
    retry(() => import('@/pages/setting/externality-reasons/edit')) as Promise<
      typeof import('@/pages/setting/externality-reasons/edit')
    >
);

export const ExternalityReasonsCreatePage = lazy(
  () =>
    retry(() => import('@/pages/setting/externality-reasons/create')) as Promise<
      typeof import('@/pages/setting/externality-reasons/create')
    >
);
